import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {vappeloffre} from 'src/app/domain';
import {CriteriaSearch} from 'src/app/domain/CriteriaSearch';
import {SharedSearchService} from '../common/shared-search.service';
import {SearchCriteria} from './search-criteria';

@Component({
    selector: 'app-input-search',
    templateUrl: './input-search.component.html',
    styleUrls: ['./input-search.component.css']
})
export class InputSearchComponent implements OnInit {

    @Input() placeholder: string = 'offres';

    @Output() search: EventEmitter<SearchCriteria[]> = new EventEmitter<SearchCriteria[]>();
    @Output() typeofsearch: EventEmitter<string> = new EventEmitter<string>();
    listoffres: vappeloffre[] = [];
    selected: string = 'Projets Programmés';
    inputText: string;

    constructor(private router: Router, private sharedService: SharedSearchService) {
        this.sharedService.compOffreVal = new CriteriaSearch(
            'bidNmFr',
            this.inputText || undefined,
            'upper_like'
        );
        this.sharedService.compProjetVal = new CriteriaSearch(
            'planNmFr',
            this.inputText || undefined,
            'upper_like'
        );
        this.sharedService.compConsultationVal = new CriteriaSearch(
            'shopNmFr',
            this.inputText || undefined,
            'upper_like'
        );
    }

    onChangeCallback: any = () => {
    };

    onTouchedCallback: any = () => {
    };

    get() {

    }

    ngOnInit(): void {

    }

    rechercher() {


        if (this.selected == 'Avis A.O' || this.selected == 'دعوات المناقصات') {
            this.sharedService.updatecompOffreVal(this.inputText);
            this.router.navigate(['/portail/offres']);
        } else if (this.selected == 'Projets Programmés' || this.selected == 'المشاريع المبرمجة') {
            this.sharedService.updatecompProjetVal(this.inputText);
            this.router.navigate(['/portail/projets']);
        } else {
            this.sharedService.updatecompConsultationVal(this.inputText);
            this.router.navigate(['/portail/consultations']);
        }

        //this.search.emit(options);
        // options.push(

        //   new CriteriaSearch(
        //     'bidNmFr',
        //     this.inputText || undefined,
        //     'like'
        //   ),
        //   new CriteriaSearch(
        //     'planNmFr',
        //     this.inputText || undefined,
        //     'like'
        //   ),
        //   new CriteriaSearch(
        //     'shopNmFr',
        //     this.inputText || undefined,
        //     'like'
        //   )

        // );

        // this.search.emit(options);
        // this.typeofsearch.emit(this.selected)


    }


}
